
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/stealth-headless-browsers",
      function () {
        return require("private-next-pages/guides/stealth-headless-browsers.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/stealth-headless-browsers"])
      });
    }
  